import api from '../../../../api';
import { Medialink } from '../../../../api/medialink';
import { NodeWithoutDescription } from '../../../../api/table-of-content';

export type SearchResultBase = {
  id: string;
  kind: string;
  name: string;
  moduleId: string;
  group: string;
  owner: string;
  sharedWithUser?: boolean;
};

export type SearchResultMedialink = SearchResultBase & {
  docType: 'medialink';
  content?: string;
  hierarchy: NodeWithoutDescription[];
  contentType: Medialink['contentType'];
};

export type SearchResultUserMaterial = SearchResultBase & {
  docType: 'usermaterial';
  content?: string;
  href?: string;
  hierarchy: NodeWithoutDescription[];
};

export type SearchResultToc = SearchResultBase & {
  docType: 'toc';
  pathTitles: string[];
};

export type SearchResultSlideSet = SearchResultBase & {
  docType: 'slideset';
  hierarchy: NodeWithoutDescription[];
};

export type SearchResultItem =
  | SearchResultMedialink
  | SearchResultToc
  | SearchResultUserMaterial
  | SearchResultSlideSet;

export type SearchResult = SearchResultItem[];

export async function search(moduleId: string, term: string) {
  const { data } = await api.get<SearchResult>(`/studio/modules/${moduleId}/medialinks/search?q=${term}`);

  return data;
}
